import Axios from "axios";
import {
    MessageBox,
    Message,
    Loading
} from 'element-ui'

Axios.create({
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Control-Allow-Origin": "*"
    },
    timeout: 5000
});

// Axios.defaults.baseURL = 'http://101.201.227.141:9911'   //测试

let loadingInstance;

// 拦截器 发送网络请求
Axios.interceptors.request.use(config => {
        if (config.url.indexOf('mobileInterf/longConnection') != -1) {


        } else {
            loadingInstance = Loading.service();
        }
        return config;
    },
    error => {
        Message.error({
            message: "加载超时"
        });
        return Promise.reject(error);
    }
);
// 拦截器 接收到网络请求
Axios.interceptors.response.use(
    response=> {
        loadingInstance.close();
        // if (response.request.responseURL.indexOf('api') != -1) {
        //     if (response.status == 200) {

        //     }
        // } else if (response.request.responseURL.indexOf('8088') != -1) {
        //     if (response.status) {

        //     }
        // } else {
        //     if (response.data.status != 200) {
        //         Message.error({
        //             message: response.data.msg
        //         });
        //     }
        // }
        return response.data
    },
    error => {
        loadingInstance.close();
        Message.error({
            message: "加载超时"
        });
        return Promise.reject(error);
    }
);
export default Axios;



// WEBPACK FOOTER //
// ./src/tools/network.js